import React from 'react'
import PrivateDiscountListContainer from '../../../../Components/DiscountPart/PrivateDiscountListContainer/PrivateDiscountListContainer'
import Layout from '../../Layout'

const PrivateDiscountList = () => {
  return (
    <Layout><PrivateDiscountListContainer/></Layout>
  )
}

export default PrivateDiscountList